<template>
  <GChart
    :settings="{packages: ['corechart']}"
    type="ColumnChart"
    :data="chartdata"
    :options="options"
	:events="chartEvents"
	ref = "gChart"
  />
</template>

<script>
import { GChart } from "vue-google-charts";

export default {
  components: { GChart },
  props: ["chartdata","chartcolumns","years","categ","subcateg"],
  data() {
    return {
      colsel: null,
      igroup: null,
      options: {
        height: 500,
        width: "100%",
        animation: {
          duration: 400,
          startup: true,
        },
        colors: ["#1b9e77", "#d95f02", "#7570b3"],
		vAxis: { minValue: 0 },
        legend: { position: "top", maxLines: 5 },
      },
      chartEvents: {
        select: () => {
          const colchart = this.$refs.gChart.chartObject;
          const selection = colchart.getSelection();
          this.igroup = selection[0].column;
          var icol =
            selection[0].row * (this.chartdata[0].length - 1) +
            selection[0].column -
            1;
          this.colsel = this.chartcolumns[icol];
          this.changeCol();
        },
      },
    };
  },
  methods: {
    runSerial(tasks) {
      var result = Promise.resolve();
      tasks.forEach((task) => {
        result = result.then(() => task());
      });
      return result;
    },
    changeCol() {
      var titlePrefix = this.subcateg.columns.filter(
        (x) => x.id == this.colsel
      )[0].title;
      var titleSuffix = this.chartdata[0][this.igroup];
      var legendTitle = titlePrefix + "（" + titleSuffix + "）";
      let tasks = [
        () => {
          $("#categ1")
            .val(this.categ.id)
            .change();
        },
        () => {
          $("#categ2")
            .val(this.subcateg.id)
            .change();
        },
        () => {
          $("#year")
            .val(this.lastYear)
            .change();
        },
        () => {
          $("#legendtitle")
            .val(legendTitle)
            .change();
        },
        () => {
          $("#categ3")
            .val(this.colsel)
            .change();
        },
        () => {
          this.$root.$emit("retract_panel");
        },
      ];

      this.runSerial(tasks);
    },
  },
  computed: {
    lastYear() {
      return this.years[this.years.length - 1];
    },
  },
};
</script>

<style>
</style>
